import React, { Component } from 'react';

import postcodeValidation from '@themejs/helpers/postcode';
import { getBtnClass } from '@triage-help/helpers';

class Location extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: {
        postcode: '',
        address: '',
        lat: null,
        lon: null,
      },
      formMessages: {
        type: null,
        content: null,
      },
    };
  }

  checkCondition(link) {
    const location = this.state.location.postcode;

    if (link.condition && location && location.length > 0) {
      if (eval(link.condition)) {
        const { postcode } = this.state.location;
        if (postcodeValidation(postcode)) {
          this.clearFormMessages();
          this.props.updateLocation(this.state.location);
          this.props.goToStep(link.target);
        } else {
          this.setState({
            formMessages: {
              type: 'error',
              content: 'Invalid postcode',
            },
          });
        }
      }
    } else {
      this.clearFormMessages();
      this.props.updateLocation(this.state.location);
      this.props.goToStep(link.target);
    }
  }

  clearFormMessages() {
    this.setState({
      formMessages: {
        type: null,
        content: null,
      },
    });
  }

  checkLocation() {
    if (navigator.geolocation) {
      this.setState({
        formMessages: {
          type: 'info',
          content: 'Loading location information.',
        },
      });

      navigator.geolocation.getCurrentPosition(
        this.handleGeoSuccess.bind(this),
        this.handleGeoError.bind(this),
      );
    }
  }

  handleGeoSuccess(e) {
    this.setState({
      location: {
        postcode: null,
        address: null,
        lat: e.coords.latitude,
        lon: e.coords.longitude,
      },
    });
    this.clearFormMessages();
    this.props.updateLocation({
      lat: e.coords.latitude,
      lon: e.coords.longitude,
    });

    const nextLink = this.props.step.link.find(l => l.type == 'next');
    this.props.goToStep(nextLink.target);
  }

  handleGeoError(e) {
    this.setState({
      formMessages: {
        type: 'error',
        content: e.message,
      },
    });
  }

  render() {
    const { step, location, goToPrev } = this.props;
    const prevLink = step.link.find(l => l.type == 'prev');

    return (
      <div className="fv-triage-card">
        <div className="row">
          <div className="col-sm-12 col-md-7 fv-triage-card__content">
            <div dangerouslySetInnerHTML={{ __html: step.content }} />
          </div>
          <div className="col-sm-12 col-md-5 fv-triage-card__side">
            <input
              type="text"
              id="postcode"
              className="fv-triage-card__text-input"
              name="postcode"
              placeholder="Postcode"
              value={this.state.location.postcode || ''}
              onChange={e =>
                this.setState({
                  location: {
                    ...this.state.location,
                    postcode: e.target.value,
                  },
                })
              }
            />
            <input
              type="text"
              id="address"
              className="fv-triage-card__text-input"
              name="address"
              placeholder="house no."
              value={this.state.location.address || ''}
              onChange={e =>
                this.setState({
                  location: {
                    ...this.state.location,
                    address: e.target.value,
                  },
                })
              }
            />
            <p className="fv-triage-card__separator">OR</p>
            {navigator.geolocation && (
              <p
                className="fv-triage-card__cta"
                onClick={() => this.checkLocation()}
              >
                <i className="icon-locate" />
                Use my current location
              </p>
            )}
            <p
              className={`tvg-region-selector__form__messages ${
                this.state.formMessages.type
                  ? `tvg-region-selector__form__messages--${this.state.formMessages.type}`
                  : ''
              }`}
            >
              {this.state.formMessages.content}
            </p>
          </div>
          <div className="col-md-12 fv-triage-card__links">
            {prevLink && (
              <button
                className={getBtnClass(prevLink.type)}
                onClick={() => goToPrev()}
              >
                {prevLink.text}
              </button>
            )}
            <div className="fv-triage-card__links__next">
              {step.link
                .filter(l => l.type != 'prev')
                .map((link, i) => {
                  let location;

                  if (typeof this.state.location.postcode == 'string') {
                    location = this.state.location.postcode;
                  } else {
                    location = new String(this.state.location.lat);
                  }

                  return (
                    <button
                      className={getBtnClass(
                        link.type,

                        link.condition ? eval(link.condition) : true,
                      )}
                      key={i}
                      onClick={() => this.checkCondition(link)}
                    >
                      {link.text}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Location;
